module.exports = __webpack_public_path__ + "static/NeueEinstellungExtraBold-879cf5a0b6935dc340b854e1515f2807.woff";